import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import ParentDashboard from "@/pages/ParentDashboard";
import SocialWorkerDashboard from "@/pages/SocialWorkerDashboard";
import AdminBilling from "@/pages/AdminBilling";

function Root() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-[#1e3a8a]" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <AdminBilling />;
  return user.role === "social_worker" ? <SocialWorkerDashboard /> : <ParentDashboard />;
}

function LoginRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginRoute />} />
            <Route path="/" element={<Root />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
